import React from 'react';

const PageHeading = ({ children, className = '', count }) => {
  return (
    <h1 className={className}>
      {children}
      {typeof count === 'number' && (
        <span className="ml-4 text-xl font-medium text-slate-200">
          / {count}
        </span>
      )}
    </h1>
  );
};

export default PageHeading;